import { useEffect } from "react";

// The global sheet puts overflow-x on <html>, so a body-only lock never reaches the viewport: lock both.
// Ref-counted so an overlay opened over another one doesn't free the page when the inner one closes.
let locks = 0;
let saved = null;

export function useLockPageScroll(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const root = document.documentElement;
    const body = document.body;
    if (locks++ === 0) {
      saved = { html: root.style.overflow, body: body.style.overflow };
      root.style.overflow = "hidden";
      body.style.overflow = "hidden";
    }
    return () => {
      if (--locks === 0 && saved) {
        root.style.overflow = saved.html;
        body.style.overflow = saved.body;
        saved = null;
      }
    };
  }, [active]);
}

// Drop inside any full-screen overlay's JSX: locks the page while the overlay is mounted.
export function PageScrollLock() {
  useLockPageScroll(true);
  return null;
}
